import React, { Component } from "react";
import Encryptacion from "../../services/Encrypt";
import { NavLink } from "react-router-dom";
import Request from "../../services/Request";
import DefaultImage from "../utils/images/default.png";
import Encrypt from "../../services/Encrypt";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = this.inicial_state;
    this.state.imagen = DefaultImage;
  }

  hrefLink = null;

  inicial_state = {
    imagen: null,
    modulos: JSON.parse(Encryptacion.getSession("modulos")),
    logout: false,
  };

  getImagen() {
    Request.GET_IMAGE(
      "usuarios/profile",
      Encryptacion.getSession("usuario")
    ).then((result) => {
      if (result !== false) {
        if (result.status === 200) {
          let blob = new Blob([result.data], {
              type: result.headers["content-type"],
            }),
            url = window.URL.createObjectURL(blob);

          this.setState({ imagen: url });
        }
      }
    });
  }
  interval_imagen = null;
  componentDidMount() {
    const side = document.createElement("script");
    side.src = `${process.env.PUBLIC_URL}/assets/js/sidebarmenu.js`;
    side.async = true;
    const custom = document.createElement("script");
    custom.src = `${process.env.PUBLIC_URL}/assets/js/custom.min.js`;
    custom.async = true;
    document.body.appendChild(custom);
    document.body.appendChild(side);

    this.interval_imagen = setInterval(async () => {
      if (Encrypt.getSession("cambio_foto")) {
        this.getImagen();

        Encrypt.destroyItemSession("cambio_foto");
      }
    }, 1);
  }

  UNSAFE_componentWillMount() {
    this.getImagen();
  }
  async logout() {
    await Encryptacion.clearSession();

    window.location.href = "/login";
  }
  render() {
    return (
      <React.Fragment>
        <header className="topbar">
          <nav className="navbar top-navbar navbar-expand-md navbar-light">
            {/* ============================================================== */}
            {/* Logo */}
            {/* ============================================================== */}
            <div className="navbar-header">
              <a className="navbar-brand" href="index.html">
                {/* Logo icon */}
                <b>
                  {/*You can put here icon as well // <i class="wi wi-sunset"></i> //*/}
                  {/* Dark Logo icon */}
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/logo_iddpues_small.png`}
                    alt="homepage"
                    className="dark-logo"
                  />
                  {/* Light Logo icon */}
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/logo_iddpues_small.png`}
                    alt="homepage"
                    className="light-logo"
                  />
                </b>
                {/*End Logo icon */}
                {/* Logo text */}
                <span>
                  {/* dark Logo text */}
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/logo_texto.png`}
                    alt="homepage"
                    className="dark-logo"
                  />
                  {/* Light Logo text */}
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/logo_texto.png`}
                    className="light-logo"
                    alt="homepage"
                  />
                </span>{" "}
              </a>
            </div>
            {/* ============================================================== */}
            {/* End Logo */}
            {/* ============================================================== */}
            <div className="navbar-collapse">
              {/* ============================================================== */}
              {/* toggle and nav items */}
              {/* ============================================================== */}
              <ul className="navbar-nav mr-auto mt-md-0">
                {/* This is  */}
                <li className="nav-item">
                  {" "}
                  <a
                    className="nav-link nav-toggler hidden-md-up text-muted waves-effect waves-dark"
                    href={this.hrefLink}
                  >
                    <i className="mdi mdi-menu" />
                  </a>{" "}
                </li>
                <li className="nav-item m-l-10">
                  {" "}
                  <a
                    className="nav-link sidebartoggler hidden-sm-down text-muted waves-effect waves-dark"
                    href={this.hrefLink}
                  >
                    <i className="ti-menu" />
                  </a>{" "}
                </li>

                {/* ============================================================== */}
                {/* ============================================================== */}
                {/* Messages */}
                {/* ============================================================== */}

                {/* ============================================================== */}
              </ul>
              {/* ============================================================== */}
              {/* User profile and search */}
              {/* ============================================================== */}
              <ul className="navbar-nav my-lg-0">
                {/* ============================================================== */}
                {/* Search */}
                {/* ============================================================== */}

                {/* ============================================================== */}
                {/* Language */}
                {/* ============================================================== */}

                {/* ============================================================== */}
                {/* Profile */}
                {/* ============================================================== */}
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle text-muted waves-effect waves-dark"
                    href={this.hrefLink}
                    data-toggle="dropdown"
                  >
                    <img
                      src={this.state.imagen}
                      alt="user"
                      className="profile-pic"
                    />
                  </a>
                  <div className="dropdown-menu dropdown-menu-right scale-up">
                    <ul className="dropdown-user">
                      <li>
                        <div className="dw-user-box">
                          <div className="u-img">
                            <img src={this.state.imagen} alt="user" />
                          </div>
                          <div className="u-text">
                            <h4>{Encryptacion.getSession("alias")}</h4>
                            <p className="text-muted">
                              {Encryptacion.getSession("correo")}
                            </p>
                          </div>
                        </div>
                      </li>
                      <li role="separator" className="divider" />
                      <li>
                        <NavLink to="/administracion/usuario/perfil">
                          <i className="ti-user mr-1" />
                          <span>Mi Perfil</span>
                        </NavLink>
                      </li>

                      <li role="separator" className="divider" />
                      <li>
                        <button
                          className="btn btn-link"
                          onClick={this.logout.bind(this)}
                        >
                          <i className="fa fa-power-off" /> Cerrar Sesión
                        </button>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </nav>
        </header>
        <aside className="left-sidebar">
          {/* Sidebar scroll*/}
          <div className="scroll-sidebar">
            {/* User profile */}
            <div className="user-profile">
              {/* User profile image */}
              <div className="profile-img">
                {" "}
                <img src={this.state.imagen} alt="user" />
                {/* this is blinking heartbit*/}
                <div className="notify setpos">
                  {" "}
                  <span className="heartbit" /> <span className="point" />{" "}
                </div>
              </div>
              {/* User profile text*/}
              <div className="profile-text">
                <h5>{Encryptacion.getSession("alias")}</h5>
                <span>{Encryptacion.getSession("rol")}</span>
              </div>
            </div>
            {/* End User profile text*/}
            {/* Sidebar navigation*/}
            <nav className="sidebar-nav">
              <ul id="sidebarnav">
                <li className="nav-devider" />
                <li className="nav-small-cap">Menú General</li>
                <li
                  className={
                    this.props.location.pathname === "/" ? "active" : ""
                  }
                >
                  {" "}
                  <NavLink exact to="/">
                    <i className="mdi mdi-gauge" />
                    <span className="hide-menu">Inicio </span>
                  </NavLink>
                </li>

                {this.state.modulos.includes(
                  "18130aec-698b-4d2e-8f24-461eff84c4af"
                ) && (
                  <li
                    className={
                      this.props.location.pathname ===
                        "/periodos_ministeriales" ||
                      this.props.location.pathname ===
                        "/periodos_ministeriales/new" ||
                      this.props.location.pathname.includes(
                        "/periodos_ministeriales/update"
                      )
                        ? "active"
                        : ""
                    }
                  >
                    <NavLink exact to="/periodos_ministeriales">
                      <i className="mdi mdi-calendar-clock" />
                      <span className="hide-menu">Periodos Ministeriales</span>
                    </NavLink>
                  </li>
                )}

                {this.state.modulos.includes(
                  "069c8570-a351-4e5b-9228-448893c18e49"
                ) && (
                  <li
                    className={
                      this.props.location.pathname.includes(
                        "/informes_mensuales/gestiones_entrega"
                      ) ||
                      this.props.location.pathname.includes(
                        "/informes_mensuales/gestiones_entrega/new"
                      ) ||
                      this.props.location.pathname.includes(
                        "/informes_mensuales/gestiones_entrega/asignados"
                      ) ||
                      this.props.location.pathname.includes(
                        "/informes_mensuales/gestiones_entrega/asignacion_informes"
                      ) ||
                      this.props.location.pathname.includes(
                        "/informes_mensuales/gestiones_entrega/update"
                      )
                        ? "active"
                        : ""
                    }
                  >
                    <NavLink exact to="/informes_mensuales/gestiones_entrega">
                      <i className="mdi mdi-clipboard-flow" />
                      <span className="hide-menu">Gestiones de Entrega</span>
                    </NavLink>
                  </li>
                )}
                {/*---INFORMES MENSUALES*/}
                <li>
                  {this.state.modulos.includes(
                    "8130362d-d425-4019-b47b-42450ee15fed"
                  ) && (
                    <a
                      className="has-arrow waves-effect waves-dark"
                      href={this.hrefLink}
                      aria-expanded="false"
                    >
                      <i className="mdi mdi-clipboard-check" />
                      <span className="hide-menu">Recepción Informes</span>
                    </a>
                  )}
                  <ul className="collapse">
                    {this.state.modulos.includes(
                      "d56cf8b1-f637-446a-9b28-28bf846bdbac"
                    ) && (
                      <li>
                        <NavLink to="/recepcion_informes/iglesia">
                          <i className="mdi mdi-church mr-1" />
                          <span>Informes Iglesias</span>
                        </NavLink>
                      </li>
                    )}
                  </ul>
                </li>

                <li>
                  {this.state.modulos.includes(
                    "f3c28a28-2922-4086-b5df-94df3cf3634b"
                  ) && (
                    <a
                      className="has-arrow waves-effect waves-dark"
                      href={this.hrefLink}
                      aria-expanded="false"
                    >
                      <i className="mdi mdi-clipboard-check" />
                      <span className="hide-menu">
                        Histórico Recepción Informes
                      </span>
                    </a>
                  )}
                  <ul className="collapse">
                    {this.state.modulos.includes(
                      "b1942651-be5b-4c3b-b6c8-d42f4df30f26"
                    ) && (
                      <li>
                        <NavLink to="/historico/recepcion_informes/iglesia">
                          <i className="mdi mdi-church mr-1" />
                          <span>Histórico Informes Iglesias</span>
                        </NavLink>
                      </li>
                    )}
                  </ul>
                </li>
                {this.state.modulos.includes(
                  "32c9c5a4-6b90-4c08-bed4-57caa03ff573"
                ) && (
                  <li>
                    <a
                      className="has-arrow waves-effect waves-dark"
                      href={this.hrefLink}
                      aria-expanded="false"
                    >
                      <i className="mdi mdi-clipboard-check" />
                      <span className="hide-menu">Presentar Informes</span>
                    </a>

                    <ul className="collapse">
                      {this.state.modulos.includes(
                        "0b691254-6df0-416b-ab79-fd6e260a6c9a"
                      ) && (
                        <li>
                          <NavLink exact to="/presentacion_informes/iglesia">
                            <i className="mdi mdi-church mr-1" />
                            <span>Informes Iglesias</span>
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
                {this.state.modulos.includes(
                  "200af944-addf-4dc3-a711-a3573389af87"
                ) && (
                  <li>
                    <a
                      className="has-arrow waves-effect waves-dark"
                      href={this.hrefLink}
                      aria-expanded="false"
                    >
                      <i className="mdi mdi-clipboard-check" />
                      <span className="hide-menu">
                        Histórico Presentación Informes
                      </span>
                    </a>

                    <ul className="collapse">
                      {this.state.modulos.includes(
                        "0876a622-667a-4676-9dd8-3cc11520e8c7"
                      ) && (
                        <li>
                          <NavLink
                            exact
                            to="/historico/presentacion_informes/iglesia"
                            className={
                              this.props.location.pathname.includes(
                                "/historico/presentacion_informes/iglesia"
                              ) ||
                              this.props.location.pathname.includes(
                                "/historico/presentacion_informes/gestiones"
                              ) ||
                              this.props.location.pathname.includes(
                                "/historico/presentacion_informes/gestion/detalles"
                              )
                                ? "active"
                                : ""
                            }
                          >
                            <i className="mdi mdi-church mr-1" />
                            <span>Histórico Informes Iglesias</span>
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
                {this.state.modulos.includes(
                  "6c89e357-045a-453b-8840-36ae6307c114"
                ) && (
                  <li>
                    <a
                      className="has-arrow waves-effect waves-dark"
                      href={this.hrefLink}
                      aria-expanded="false"
                    >
                      <i className="mdi mdi-clipboard-text" />
                      <span className="hide-menu">Nombramientos</span>
                    </a>

                    <ul className="collapse">
                      {this.state.modulos.includes(
                        "6d04def8-20d0-4f6d-84ba-6320181879f8"
                      ) && (
                        <li>
                          <NavLink
                            exact
                            to="/nombramientos/pastorales"
                            className={
                              this.props.location.pathname.includes(
                                "/nombramientos/pastorales"
                              ) ||
                              this.props.location.pathname.includes(
                                "/nombramientos/pastorales/create"
                              ) ||
                              this.props.location.pathname.includes(
                                "/nombramientos/pastorales/update"
                              ) ||
                              this.props.location.pathname.includes(
                                "/nombramientos/pastorales/gestion"
                              )
                                ? "active"
                                : ""
                            }
                          >
                            <i className="mdi mdi-account-multiple mr-1" />
                            <span>Pastores</span>
                          </NavLink>
                        </li>
                      )}

                      {this.state.modulos.includes(
                        "17027efa-869a-420b-823a-957e3e08cfee"
                      ) && (
                        <li>
                          <NavLink exact to="/nombramientos/lideres_nacionales">
                            <i className="mdi mdi-account-multiple mr-1" />
                            <span>Lideres Nacionales</span>
                          </NavLink>
                        </li>
                      )}

                      {this.state.modulos.includes(
                        "fc6b168b-172f-4e73-b8d3-679e1e1c1eb2"
                      ) && (
                        <li>
                          <NavLink exact to="/nombramientos/lideres_locales">
                            <i className="mdi mdi-account-multiple mr-1" />
                            <span>Lideres Locales</span>
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </li>
                )}

                {this.state.modulos.includes(
                  "4de7f531-714b-4a4c-a173-f6da077e37a5"
                ) && (
                  <li
                    className={
                      this.props.location.pathname === "/membresia" ||
                      this.props.location.pathname.includes(
                        "/membresia/iglesia"
                      ) ||
                      this.props.location.pathname.includes(
                        "/membresia/iglesia/add"
                      ) ||
                      this.props.location.pathname.includes(
                        "/membresia/iglesia/update"
                      )
                        ? "active"
                        : ""
                    }
                  >
                    <NavLink exact to="/membresia">
                      <i className="mdi mdi-account-location" />
                      <span className="hide-menu">Membresía Local</span>
                    </NavLink>
                  </li>
                )}
                <li>
                  {" "}
                  {this.state.modulos.includes(
                    "79f92aab-e480-4037-bfcd-fb85a7405fe7"
                  ) && (
                    <a
                      className="has-arrow waves-effect waves-dark"
                      href={this.hrefLink}
                      aria-expanded="false"
                    >
                      <i className="mdi mdi-account-multiple" />
                      <span className="hide-menu">Recursos Humanos</span>
                    </a>
                  )}
                  <ul className="collapse">
                    {this.state.modulos.includes(
                      "1a087be0-a30e-4d26-af29-1846a20e2d1a"
                    ) && (
                      <li>
                        <NavLink to="/recursos_humanos/niveles_pastorales">
                          <i className="mdi mdi-file-chart mr-1" />
                          <span>Niveles Pastorales</span>
                        </NavLink>
                      </li>
                    )}
                    {this.state.modulos.includes(
                      "e2708ad4-a123-4c1b-bf3b-b599a4e778fe"
                    ) && (
                      <li>
                        <NavLink to="/recursos_humanos/cargos_ministeriales">
                          <i className="mdi mdi-book-open mr-1" />
                          <span>Cargos Ministeriales</span>
                        </NavLink>
                      </li>
                    )}
                    {this.state.modulos.includes(
                      "68ff3ca6-05c7-450b-9d6f-5e315ef76d6e"
                    ) && (
                      <li>
                        <NavLink to="/recursos_humanos/niveles_academicos">
                          <i className="mdi mdi-file-chart mr-1" />
                          <span>Niveles Académicos Teológicos</span>
                        </NavLink>
                      </li>
                    )}
                    {this.state.modulos.includes(
                      "9c464bd0-6015-4927-a881-9b0005c645ed"
                    ) && (
                      <li>
                        <NavLink to="/recursos_humanos/personas">
                          <i className="mdi mdi-account-card-details mr-1" />
                          <span>Personas</span>
                        </NavLink>
                      </li>
                    )}
                    {this.state.modulos.includes(
                      "753278e6-c194-4858-ab8e-5d3760cf5ea4"
                    ) && (
                      <li>
                        <NavLink to="/recursos_humanos/pastores">
                          <i className="mdi mdi-account-card-details mr-1" />
                          <span>Pastores</span>
                        </NavLink>
                      </li>
                    )}
                  </ul>
                </li>
                <li>
                  {this.state.modulos.includes(
                    "efc079e7-b7ee-4c5c-b904-ea5b604f4433"
                  ) && (
                    <a
                      className="has-arrow waves-effect waves-dark"
                      href={this.hrefLink}
                      aria-expanded="false"
                    >
                      <i className="mdi mdi-book-open" />
                      <span className="hide-menu">Organización</span>
                    </a>
                  )}
                  <ul className="collapse">
                    {this.state.modulos.includes(
                      "c13a1b4d-612a-4f46-ba98-6b0bc5e10e47"
                    ) && (
                      <li>
                        <NavLink to="/organizacion/zonas">
                          <i className="mdi mdi-google-maps mr-1" />
                          <span>Zonas</span>
                        </NavLink>
                      </li>
                    )}

                    {this.state.modulos.includes(
                      "dcc3ec83-1367-4166-94e2-ba46c9c029a1"
                    ) && (
                      <li>
                        <NavLink to="/organizacion/distritos">
                          <i className="mdi mdi-map-marker-radius mr-1" />
                          <span>Distritos</span>
                        </NavLink>
                      </li>
                    )}
                    {this.state.modulos.includes(
                      "ca8b7b5c-652d-46db-a640-6ce29b6e7457"
                    ) && (
                      <li>
                        <NavLink to="/organizacion/iglesias">
                          <i className="mdi mdi-church mr-1" />
                          <span>Iglesias</span>
                        </NavLink>
                      </li>
                    )}

                    {this.state.modulos.includes(
                      "b5dcf605-897d-4521-9464-7176e234fd98"
                    ) && (
                      <li>
                        <NavLink to="/administracion/configuracion">
                          <i className="mdi mdi-settings mr-1" />
                          <span>Configuración</span>
                        </NavLink>
                      </li>
                    )}
                  </ul>
                </li>
                <li>
                  {" "}
                  {this.state.modulos.includes(
                    "d5213ccc-c971-40dc-a813-cc63ccfacf13"
                  ) && (
                    <a
                      className="has-arrow waves-effect waves-dark"
                      href={this.hrefLink}
                      aria-expanded="false"
                    >
                      <i className="mdi mdi-timetable" />
                      <span className="hide-menu">Administración</span>
                    </a>
                  )}
                  <ul className="collapse">
                    {this.state.modulos.includes(
                      "6036af3b-234f-4c74-bdec-53a457f39d0a"
                    ) && (
                      <li>
                        <NavLink to="/administracion/maestro_informes">
                          <i className="mdi mdi-file-document mr-1" />
                          <span>Maestro de Informe</span>
                        </NavLink>
                      </li>
                    )}
                    {this.state.modulos.includes(
                      "f91cdcdd-6623-47d7-ae19-87b75e966ff6"
                    ) && (
                      <li>
                        <NavLink to="/administracion/modulos">
                          <i className="mdi mdi-book-multiple mr-1" />
                          <span>Módulos</span>
                        </NavLink>
                      </li>
                    )}

                    {this.state.modulos.includes(
                      "289fd42f-b5d7-430f-a753-13ec027e4134"
                    ) ? (
                      <li>
                        <NavLink to="/administracion/roles">
                          <i className="fa fa-key mr-1" />
                          <span>Roles</span>
                        </NavLink>
                      </li>
                    ) : null}

                    {this.state.modulos.includes(
                      "0e265555-6b54-4f97-b520-c836c4f7b215"
                    ) && (
                      <li>
                        <NavLink to="/administracion/usuarios">
                          <i className="mdi mdi-account-key mr-1" />
                          <span>Usuarios</span>
                        </NavLink>
                      </li>
                    )}

                    {this.state.modulos.includes(
                      "81ea746c-7539-4ff6-b33b-d8bf62f8af9e"
                    ) && (
                      <li>
                        <NavLink to="/administracion/impuestos_especiales">
                          <i className="mdi mdi-gavel mr-1" />
                          <span>Impuestos Especiales</span>
                        </NavLink>
                      </li>
                    )}
                    {this.state.modulos.includes(
                      "d5cd3659-e9d6-4c6f-afae-3d9d1d9c0032"
                    ) && (
                      <li>
                        <NavLink to="/administracion/tipos_documento">
                          <i className="mdi mdi-account-card-details mr-1" />
                          <span>Tipos de Documentos</span>
                        </NavLink>
                      </li>
                    )}
                    {this.state.modulos.includes(
                      "f4dcf8a2-8824-42f8-b8fe-8a0956f2d300"
                    ) && (
                      <li>
                        <NavLink to="/administracion/unidades_medida">
                          <i className="mdi mdi-scale-balance mr-1" />
                          <span>Unidades de Medida</span>
                        </NavLink>
                      </li>
                    )}
                    {this.state.modulos.includes(
                      "b5dcf605-897d-4521-9464-7176e234fd98"
                    ) && (
                      <li>
                        <NavLink to="/administracion/configuracion">
                          <i className="mdi mdi-settings mr-1" />
                          <span>Configuración</span>
                        </NavLink>
                      </li>
                    )}
                  </ul>
                </li>
                <li
                  className={
                    this.props.location.pathname === "/soporte-tecnico"
                      ? "active"
                      : ""
                  }
                >
                  {" "}
                  <NavLink exact to="/soporte-tecnico">
                    <i className="mdi mdi-developer-board" />
                    <span className="hide-menu">Soporte Técnico </span>
                  </NavLink>
                </li>
              </ul>
            </nav>
            {/* End Sidebar navigation */}
          </div>
          {/* End Sidebar scroll*/}
        </aside>
      </React.Fragment>
    );
  }
}

export default Header;
